import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { finalize } from 'rxjs/operators';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { CustomerService } from 'src/app/customer/customer.service';
import { CommonDataModel } from '../common-data-model';
import { LeadAccountAddFormComponent } from '../lead-account-add-form/lead-account-add-form.component';
import { AddQuickContactComponentForm } from '../quick-contact/add-quick-contact-form.component';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonMethod } from 'src/app-core/methods/common-methods';

@Component({
    selector: 'app-orders-custom-address',
    templateUrl: './orders-custom-address.component.html',
    styleUrls: ['./orders-custom-address.component.scss']
})
export class OrdersCustomAddressComponent implements OnInit {
    @Output() emitCustomAddress: EventEmitter<any> = new EventEmitter<any>();
    @Input() shippingType: any;
    @Input() accountId: boolean;
    @Input() readOnly: boolean;
    @Input() set rfqData(rfqData: any) {
        if (rfqData) {
            this.rfqDetails = rfqData;
            this.setDataForRFQ();
        }
    }
    pattern = new CustomPattern();
    commonDataModel = new CommonDataModel();
    ordersCustomAddress = Object.assign({}, this.commonDataModel.shippingCustomAddressModel);
    ordersContact = Object.assign({}, this.commonDataModel.ordersContactModel);
    viewCustomAddressForm = true;
    isFormLoading = false;
    rfqDetails: any;
    commonConstants: typeof CommonConstants = CommonConstants;

    constructor(private contactService: ContactService,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        private accountService: CustomerService,
        private dialog: MatDialog,
    ) { }

    ngOnInit() {
    }

    setDataForRFQ() {
        this.ordersCustomAddress.zipCode = this.rfqDetails.destinationZip;
    }

    onSaveCustomAddress() {
        this.isFormLoading = true;
        if (this.ordersCustomAddress.name && !this.ordersCustomAddress.name.replace(/\s/g, '').length) {
            this.ordersCustomAddress.name = null;
        }
        this.commonService.objectMapping(this.ordersContact, this.ordersCustomAddress);
        this.ordersContact.accountId = this.accountId;
        this.ordersContact.zipCode = this.ordersCustomAddress.zipCode;
        this.contactService.createQuickContact(this.ordersContact)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                if (response.isSuccess) {
                    this.commonService.objectMapping(this.ordersCustomAddress, response.data);
                    this.ordersCustomAddress.contactId = response.data.id;
                    this.viewCustomAddressForm = false;
                    this.ordersCustomAddress.isActive = true;
                    this.ordersCustomAddress.shippingType = this.shippingType;
                    this.ordersCustomAddress.accountId = response.data.accountId;
                    this.ordersCustomAddress.isQuickContact = true;
                    this.isFormLoading = false;
                    this.emitCustomAddress.emit(this.ordersCustomAddress);
                }
            });
    }

    onClear() {
        this.ordersCustomAddress = Object.assign({}, this.commonDataModel.shippingCustomAddressModel);
    }


    onAddNewLead() {
        this.dialog
            .open(LeadAccountAddFormComponent, {
                position: {
                    right: '0',
                },
                panelClass: 'small_layout',
                hasBackdrop: false,
                autoFocus: false,
                // if quick Account pass true else false
                data: { isQuickAccount: false }
            }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.leadId) {
                    this.ordersCustomAddress.isQuickContact = false;
                    this.getLeadAccountDetails(response.leadId);
                }
            });
    }

    getLeadAccountDetails(accountId: string): void {
        this.accountService.getAccount(accountId).subscribe(response => {
            if (response.isSuccess) {
                this.ordersCustomAddress.provinceName = response.data.primaryProvince;
                this.ordersCustomAddress.addressLine1 = response.data.primaryAddress;
                this.ordersCustomAddress.zipCode = response.data.primaryZipCode;
                this.ordersCustomAddress.contactId = response.data.contactId;
                this.ordersCustomAddress.email = response.data.primaryEmail;
                this.ordersCustomAddress.phone = response.data.primaryNumber;
                this.ordersCustomAddress.city = response.data.primaryCity;
                this.ordersCustomAddress.countryName = response.data.primaryCountry;
                this.viewCustomAddressForm = false;
                this.ordersCustomAddress.isActive = true;
                this.ordersCustomAddress.shippingType = this.shippingType;
                this.ordersCustomAddress.accountName = response.data.accountName;
                this.ordersCustomAddress.contactName = response.data.primaryContact;
                this.ordersCustomAddress.accountId = response.data.id;
                this.ordersCustomAddress.addressId = response.data.addressId;
                this.ordersCustomAddress.accountNotes = response.data.accountNotes;
                this.ordersCustomAddress.addressIndicator = response.data.addressIndicator;
                this.ordersCustomAddress.primaryExt = response.data.primaryPhoneExtension;
                this.isFormLoading = false;
                this.emitCustomAddress.emit(this.ordersCustomAddress);
            }
        });
    }

    onChangeAllowInternationalZip(event: any) {
        let internationalChecked = event.checked;
        this.commonMethod.sendIsInternationalZipcode(internationalChecked);
        if (!internationalChecked) {
            this.ordersCustomAddress.zipCode = '';
        }
    }

    onAddNewQuickAccount() {
        this.dialog
            .open(AddQuickContactComponentForm, {
                position: {
                    right: '0',
                },
                panelClass: 'small_layout',
                hasBackdrop: false,
                autoFocus: false,
                // if quick Account pass true else false
                data: { isQuickAccount: true, isCreate: true, accountId: this.accountId }
            }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.accountId) {
                    this.ordersCustomAddress.isQuickContact = true;
                    this.getLeadAccountDetails(response.accountId);
                }
            });
    }
}
